module.exports = __webpack_public_path__ + "img/b06.11ed9e7e.png";